import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthUtilsService } from '../../services/auth-utils.service';

@Component({
  selector: 'app-onboarding-footer',
  templateUrl: './onboarding-footer.component.html',
  styleUrls: ['./onboarding-footer.component.scss'],
})
export class OnboardingFooterComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() showButton: boolean = true;
  @Input() hiddenPrimaryBtn: boolean = false;
  @Input() privacyPolicy: boolean = true;
  @Input() hint?: string;
  @Input() label: string = 'Confirmar';
  @Input() alertMessage?: string;
  @Input() buttonColor: 'primary' | 'secondary' | 'basic' | 'cancel' = 'primary';
  @Input() type?: 'reminder' | 'warning' | 'error' | 'confirm' = 'warning';
  @Input() borderTop: boolean;
  @Input() positionAbsolute: boolean = true;
  @Input() labelSecondary: string;
  @Input() hiddenIcon: boolean;
  @Output() confirm = new EventEmitter();
  @Output() actionSecondaryBtn = new EventEmitter();

  constructor(public utils: AuthUtilsService) {}

  ngOnInit(): void {}
}
